<template>
  <link href="https://fonts.cdnfonts.com/css/barlow" rel="stylesheet" />
  <div class="hello">
    <div style="display:flex; justify-content: center;">
      <!--h2 class="main-header">Assistente Hygea</h2-->
      <img class="icon main-icon" src="@/assets/img/wide-logo.svg" alt="" />
      <!--img class="icon sup-dir-icon" src="@/assets/img/wide-line.svg" alt="" /-->
    </div>


    <div class="main-chatbox">
      <input placeholder="Type your question." type="text" class="search-input" @keyup.enter="onEnter"
        v-model="textBox" />
      <img @click="onEnter" class="icon search-icon" src="@/assets/img/lupa.svg" alt="" />
    </div>
    <div class="chatbox-wrapper">
      <span class="loading" v-if="isLoading">Please wait, processing your question...</span>
      <div id="chatbox" class="main-chatmessage">
        <div v-for="(msg, index) in msgs" :key="index">
          <div align="left" class="box user-box">
            <img class="icon user-icon" src="@/assets/img/user-icon.jpg" alt="" />
            <div class="user-text">
              <span> {{ msg.user }}</span>
            </div>
          </div>
          <div v-for="(document, index) in msg.bot.documents" :key="index" align="left" class="box bot-box">
            <div class="user-icon-wrapper">
              <img class="icon user-icon" src="@/assets/img/ai-icon.jpg" alt="" />
            </div>
            <div>
              <span v-html="document.abstract"> </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--img class="icon inf-esq-icon" src="@/assets/img/inf-esq.svg" alt="" /-->
  </div>
</template>

<script>
import backgroundImage from '@/assets/img/wide-background.png';

export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
    data() {
    return {
      botAnswer: "Justo",
      msgs: [],
      textBox: "",
      response: [],
      isLoading: false,
      backgroundImage: backgroundImage,
      conversation_uuid: null, // <-- Aqui armazenamos o UUID da conversa
    };
  },
  computed: {
  },
  methods: {
    redirect(link) {
      window.open(link, "_blank");
    },
    convertHttpsLinksToAnchors(text) {
      // Regular expression to match links that start with "https" and end with "htm" or "html"
      const linkRegex = /https:\/\/[\w\-._~:/?#[\]@!$&'()*+,;=]*\.htm[l]?/g;

      // Replace matched links with anchor tags
      return text.replace(linkRegex, function (match) {
        return `<a href="${match}" target="_blank" rel="noopener noreferrer">${match}</a>`;
      });
    },
    markdownToHTML(markdown) {
      // Replace Markdown headers (h1 - h6)
      markdown = markdown.replace(/(#+)(.*)/g, function (match, hashes, text) {
        var level = hashes.length;
        return "<h" + level + ">" + text.trim() + "</h" + level + ">";
      });

      // Replace Markdown bold (**text** or __text__)
      markdown = markdown.replace(
        /\*\*(.*?)\*\*|__(.*?)__/g,
        "<strong>$1$2</strong>"
      );

      // Replace Markdown italic (*text* or _text_)
      markdown = markdown.replace(/\*(.*?)\*|_(.*?)_/g, "<em>$1$2</em>");

      // Replace Markdown inline code (`code`)
      markdown = markdown.replace(/`(.*?)`/g, "<code>$1</code>");

      // Replace Markdown links ([text](url))
      markdown = markdown.replace(
        /\[([^[]+)\]\(([^)]+)\)/g,
        '<a href="$2">$1</a>'
      );

      // Replace Markdown images (![alt text](image url))
      markdown = markdown.replace(
        /!\[([^[]*)\]\(([^)]+)\)/g,
        '<img src="$2" alt="$1">'
      );

      // Replace Markdown line breaks (two spaces at the end of a line)
      markdown = markdown.replace(/ {2}\n/g, "<br />\n");

      return this.convertHttpsLinksToAnchors(markdown);
    },
    
    async onEnter() {
      if (this.isLoading) return false;

      const axios = require("axios");
      this.isLoading = true;

      // Monta o corpo da requisição
      const payload = { query: this.textBox };
      if (this.conversation_uuid) {
        payload.conversation_uuid = this.conversation_uuid;
      }

      try {
        const response = await axios.post(
          "https://dev-api.sana.widelabs.com.br/v1/sana/chat",
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        // Salva o UUID se ainda não tiver
        if (!this.conversation_uuid && response.data.conversation_uuid) {
          this.conversation_uuid = response.data.conversation_uuid;
        }

        // Exibe a resposta do bot
        const document = {
          name: "Resposta",
          abstract: this.markdownToHTML(response.data.response),
          link: "#",
          tags: [],
        };

        this.msgs = [
          {
            bot: {
              documents: [document],
            },
            user: this.textBox,
          },
          ...this.msgs,
        ];

        this.textBox = "";
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        this.isLoading = false;
      }

      return true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  font-family: "Fractul", Sans-serif;
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #01C5AD;
}

i {
  cursor: pointer;
  color: #4ac0de;
}

.main-header {
  color: #ffffff;
  margin-top: 10vh;
}

.hello {
  position: absolute;
  width: 100vw;
  height: 100vh;
  background-image: "";
  overflow: hidden;
}
.loading{
  color: #0000FF;
  font-weight: bold;
  margin: 2vh 0;
}
.sup-dir-icon {
  position: absolute;
  width: 50vw;
  right: 10vw;
  margin: 0px !important;
}

.inf-esq-icon {
  position: absolute;
  width: 10vw;
  left: 0px;
  bottom: 0px;
  z-index: 0;
}

.main-chatbox {
  position: absolute;
  top: 18vh;
  left: 5vw;
  width: 90vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #FFFFFF;
  border: solid 1px #0000FF;
  border-radius: 24px;
}
.main-chatbox input::placeholder{
  color: #0000FF;
}

.chatbox-wrapper {
  position: absolute;
  top: 30vh;
  left: 5vw;
  width: 88vw;
  height: 63vh;
  background-color: #F6F6F6;
  border: solid 1px #0000FF;
  border-radius: 24px;
  z-index: 1;
  padding: 2vh 1vw;
}

.main-chatmessage {
  width: 88.5vw;
  max-height: 63vh;
  overflow-y: scroll;
  background-color: #F6F6F6;
  border-radius: 24px;
}

.tags {
  padding: 10px;
  margin: 5px 10px;
  border-radius: 24px;
  background-color: #0000FF;
  color: white;
}

.box {
  background-color: #D9D9D9;
  border: none;
  margin: 1vh 1vw;
  padding: 15px;
  border-radius: 24px;
  color: #000000;
}

.user-box {
  display: flex;
  align-items: center;
  background-color: #fff;
}
.bot-box {
  display: flex;
  align-items: stretch;
  background-color: #E0E1EA;
}

.icon {
  margin-right: 2vw;
}

.user-icon-wrapper {
  display: flex;
  align-items: flex-start;
}

.user-icon {
  width: 3vw;
  border-radius: 2vw;
}

.search-input {
  width: 90vw;
  border: 0px;
  margin-left: 20px;
  background-color: #ffffff;
  height: 5vh;
  font-size: 18px;
}

.search-input:focus{
  outline: none;
}
.search-input::placeholder{
  color: #173557;
}

.main-icon {
  margin-top: 6vh;
  height: 6vh;
  margin-right: 0;
}

.search-icon {
  height: 3vh;
  width: 3vh;
  margin: 2vh;
}

.document-name {
  color: #0000FF;
  font-weight: bolder;
}

::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  background: #dddddd;
}

::-webkit-scrollbar-thumb {
  background: #0000FF;
  width: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #0000FF;
}

::-webkit-scrollbar-button {
  display: none;
}

@media only screen and (max-width: 600px) {
  .search-input {
    font-size: 14px;
  }
  .loading{
    font-size: 14px;
  }
  .user-icon {
    width: 5vh;
    border-radius: 3vh;
    margin-right: 2vh;
  }
  .main-icon {
    margin-top: 5vh;
    height: 5vh;
    margin-right: 0;
  }
  .main-chatbox {
    top: 15vh;
  }
  .chatbox-wrapper{
    top: 25vh;
  }

  .main-chatmessage, .chatbox-wrapper{
    height: 67vh;
  }
}
</style>
